module.exports = __webpack_public_path__ + "static/media/15UN-Habitat15.73e56417.jpg";